<template>
	<td :class="[
			'text-no-wrap',
			'text-center',
			'caption',
			grey ? 'primary--text text--lighten-4' : ''
		]"
		style="height: 36px;"
	>
		<v-row>
			<v-col cols="6" class="py-1">
				<template v-if="editMode">
					<a-number-field-inline
						ref="percent"
						class="caption"
						v-model="percent"
						suffix="%"
						digits="0"
						@focus="$emit('focus')"
						@blur="$emit('blur')"
						@change="percentChange"
					>
						<template v-slot:prepend-inner>
							<v-icon x-small class="py-2">add</v-icon>
						</template>
					</a-number-field-inline>
				</template>
				<template v-else>
					+ {{ percent }}%
				</template>
			</v-col>
			<v-col cols="6" class="py-1">
				<template v-if="editMode">
					<a-number-field-inline
						ref="sum"
						class="caption"
						v-model="sum"
						@focus="$emit('focus')"
						@blur="$emit('blur')"
						@change="sumChange"
					></a-number-field-inline>
				</template>
				<template v-else>
					{{ sum }}
				</template>
			</v-col>
		</v-row>
	</td>
</template>

<script>
	import { toStr, toNum } from '../../../js/common'
	import { c } from '../../../lib/const'
	import aNumberFieldInline from '../../base/ANumberFieldInline.vue'

	export default {
		components: {
			aNumberFieldInline,
		},
		props: {
			sumNet: [ String, Number ],
			sumGross: [String, Number],
			editMode: Boolean,
			grey: Boolean,
		},
		data: function() {
			return {
				percent: '',
				sum: ''
			}
		},
		watch: {
			sumNet(val, old) {
				// console.log('component - sumNet watcher', val)

				if (old != 0) {
					this.sum = toStr((1 + toNum(this.percent) / 100) * val)
				}
				else {
					this.sum = toStr((1 + c.VAT/100) * val)
					this.percent = c.VAT
				}

				this.$emit('update:sumGross', this.sum)
			}
		},
		created() {
			this.sumChange(this.sumGross, false)
		},
		methods: {
			percentChange(val, emit) {
				if (emit === undefined) emit = true

				val = toNum(val)
				val = val < 0 ? 0 : val
				val = val > 20 ? 20 : val
				// console.log('val', val)
				this.percent = val.toFixed(0)
				this.sum = toStr((100 + val) / 100 * this.sumNet)

				if (emit) {
					this.$emit('update:sumGross', this.sum)
				}
			},
			sumChange(val, emit) {
				if (emit === undefined) emit = true
				// console.log('sumChange', val)
				// console.log('sumNet', this.sumNet)

				val = toNum(val)
				// console.log('val', val)
				val = val < this.sumNet ? this.sumNet : val
				// console.log('val', val)
				let max = this.sumNet * (1 + c.VAT / 100)
				// console.log('max', max)
				// console.log('val', val)
				val = val > max ? max : val
				// console.log('val', val)
				this.sum = toStr(val)
				// console.log('sum', this.sum)

				if (this.sumNet != 0) {
					this.percent = (toNum(this.sum) / this.sumNet * 100 - 100).toFixed(0)
				}
				else {
					this.percent = 0
				}

				if (emit) {
					this.$emit('update:sumGross', this.sum)
				}
			},
			toStr(val) {
				return toStr(val)
			},
		}
	}
</script>

<style scoped>

</style>
